import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const serviceID = import.meta.env.VITE_SERVICE_ID;
    const templateID = import.meta.env.VITE_MSG_TEMPLATE_ID;
    const userID = import.meta.env.VITE_USER_ID;

    emailjs.sendForm(serviceID, templateID, form.current, userID).then(
      () => {
        toast.success('Message sent successfully', {
          position: 'top-center',
          autoClose: 5000,
          theme: 'light',
        });
        e.target.reset();
      },
      (e) => {
        toast.error('Message not sent', {
          position: 'top-center',
          autoClose: 5000,
          theme: 'light',
        });
      }
    );
  };

  return (
    <>
      <form className='space-y-4' ref={form} onSubmit={sendEmail}>
        <div>
          <label htmlFor='fullName' className='font-body'>
            Full name
          </label>
          <input
            type='text'
            id='fullName'
            name='fullName'
            placeholder='Enter fullname'
            required
            className='w-full px-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-primary'
          />
        </div>
        <div>
          <label htmlFor='email' className='font-body'>
            Email
          </label>
          <input
            type='email'
            id='email'
            name='email'
            placeholder='Enter email'
            className='w-full px-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-primary'
            required
          />
        </div>
        <div>
          <label htmlFor='phoneNumber' className='font-body'>
            Phone number
          </label>
          <input
            type='tel'
            id='phoneNumber'
            name='phoneNumber'
            placeholder='Enter phone number'
            required
            className='w-full px-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-primary'
          />
        </div>
        <div>
          <label htmlFor='message' className='font-body'>
            Message
          </label>
          <textarea
            type='text'
            id='message'
            name='message'
            placeholder='Add your message'
            className='w-full px-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-primary'
          ></textarea>
        </div>
        <button
          type='submit'
          className='w-full bg-linear-to-r from-lime-400 to-yellow-primary hover:from-lime-500 hover:to-yellow-secondary text-gray-900 font-bold py-3 px-6 rounded-lg shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-lime-300 focus:ring-opacity-75'
        >
          Send message
        </button>
      </form>
    </>
  );
};

export default ContactUs;
